export default [
  {
    path: '/admin/trader/quick-gain',
    name: 'QuickGain',
    component: () => import('@/views/Admin/Trader/QuickGain/Index.vue'),
    meta: {
      pageTitle: 'Quick Gain',
      breadcrumb: [
        { text: 'Trader', active: false },
        { text: 'Quick Gain', active: true },
      ],
      resource: 'edges.manage',
      action: 'read',
    },
  },
]
